import type { ChatMessageResponseAllOfBasicInfoAllOfTwoType } from './chatMessageResponseAllOfBasicInfoAllOfTwoType';

/**
 * 메시지 기본 정보
 */
export type ChatMessageResponseAllOfBasicInfoAllOfTwo = {
  content?: string;
  type?: ChatMessageResponseAllOfBasicInfoAllOfTwoType;
};
